import { render } from "./QcListPage.vue?vue&type=template&id=813e1d34&scoped=true"
import script from "./QcListPage.vue?vue&type=script&lang=js"
export * from "./QcListPage.vue?vue&type=script&lang=js"

import "./QcListPage.vue?vue&type=style&index=0&id=813e1d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813e1d34"]])

export default __exports__